import { Center, Spinner, StackDivider, VStack } from '@chakra-ui/react';
import { ProductionLine } from 'components';
import { SimplePageTemplate } from 'components/@common/layout';
import { RiLineChartLine } from 'react-icons/ri';
import { useStore } from 'store';

const Content = () => {
  const [store] = useStore();

  return (
    <VStack w='100%' h='100%' spacing={3} divider={<StackDivider />} overflowX={'auto'}>
      {store.location.productionLines.length > 0 ? (
        store.location.productionLines.map((line) => <ProductionLine {...line} key={line.id} />)
      ) : (
        <Center h='100%'>
          <Spinner size='lg' />
        </Center>
      )}
    </VStack>
  );
};

export const ProductionTimeline = () => {
  return (
    <SimplePageTemplate
      {...{
        title: 'Production tasks',
        icon: RiLineChartLine,
      }}
      content={<Content />}
    />
  );
};
